import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { projectFirestore } from '../../firebase/config';
import { doc, getDoc } from 'firebase/firestore';
import loadingLogo from '../../assets/MyLogo.svg';

export default function ProjectPage() {
  const { id } = useParams();
  const [project, setProject] = useState(null);
  const [isPending, setIsPending] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    setIsPending(true);

    const getProject = async () => {
      try {
        const projectRef = doc(projectFirestore, 'projects', id);
        const docSnap = await getDoc(projectRef);
        if (docSnap.exists()) {
          setIsPending(false);
          setProject(docSnap.data());
        } else {
          setError('No Project to Load');
          setIsPending(false);
        }
      } catch (err) {
        setError(err.message);
        setIsPending(false);
      }
    };
    getProject();
  }, [id]);

  return (
    <section>
      {error && <p className="error">{error}</p>}
      {isPending && <img src={loadingLogo} className="loading" />}
      {project && (
        <div className="text-center">
          <h3 className="text-accent font-bold mb-5 text-2xl md:text-4xl lg:text-6xl">
            {project.title}
          </h3>
          <p className="details ">{project.intro}</p>
          <h4 className="head-title">Project Overview</h4>

          <p className="details">{project.overview}</p>

          <h4 className="head-title">Key Features</h4>
          <p className="details">
            {project.details.map((detail, i) => (
              <p className="details" key={i}>
                {detail}{' '}
              </p>
            ))}
          </p>
          <hr className="border-[1px] border-accent" />
          <p className="text-gold font-bold text-lg md:text-2xl my-3">
            This Project was built with
          </p>
          <ul className="flex flex-wrap justify-center align-center w-fit mx-auto font-monoBody text-lg lg:text-2xl text-ash-200">
            {project.stack.map((lang, i) => (
              <li key={i} className="mr-4 stack">
                {lang}
              </li>
            ))}
          </ul>

          <a href={project.link} className="btn-link" target="_blank">
            View Project
          </a>
        </div>
      )}
    </section>
  );
}
